import { NumberParser } from './number';
/**
 * The ByteParser is a unit-specific NumberParser
 * that returns a value in bytes
 *
 * @export
 * @class ByteParser
 * @implements {FieldParserInterface<Byte>}
 */
export class ByteParser {
    /** @inheritdoc */
    parseValue(rawValue) {
        const parser = NumberParser.shared;
        return parser.parseValue(rawValue);
    }
}
// use a shared static instance for performance instead of
// instantiating a new instance for every use
ByteParser.shared = new ByteParser();
//# sourceMappingURL=byte.js.map